import 'css-chunksrc/client/scenes/projectExternalLinks/linkForm/styles.scss';export default {
  "linkForm": "_linkForm_ucf5y_1",
  "group": "_group_ucf5y_10",
  "label": "_label_ucf5y_14",
  "input": "_input_ucf5y_20",
  "url": "_url_ucf5y_35"
};